import React from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";
import { SEO } from "../components/SEO";

const NotFound = () => (
    <div
        className="container-x py-20 text-center min-h-[60vh] flex flex-col items-center justify-center"
        data-testid="not-found-page"
    >
        <SEO title="Page introuvable | Pronospot.com" description="La page demandée n'existe pas." />
        <div className="font-heading text-7xl font-extrabold text-[#00C853] mb-2">
            404
        </div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white mb-3">
            Page introuvable
        </h1>
        <p className="text-gray-400 max-w-md mb-6">
            La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <Link to="/" className="btn-green">
            <HomeIcon size={16} />
            Retour à l'accueil
        </Link>
    </div>
);

export default NotFound;
